import { render, staticRenderFns } from "./OrganizationLocations.vue?vue&type=template&id=2e636d21&"
import script from "./OrganizationLocations.vue?vue&type=script&lang=js&"
export * from "./OrganizationLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports